<!--
 * @Description: 这是头部导航页面（组件）
 * @Date: 2021-06-02 17:39:46
 * @Author: 小萝卜
 * @LastEditors: pzf
 * @LastEditTime: 2021-10-19 09:41:56
-->
<!--  -->
<template>
    <div
        id="header-back"
        :style="{
            backgroundColor: bg,
            position: position,
            top: top,
        }"
    >
        <div class="header-title flex" v-if="align !== 'left'">
            <a
                href="javascript:;"
                class="nav-btn-left"
                @click="goBack()"
            />
            <p class="common-title-text ellipsis" :style="{ color: color }">
                {{ headTitle }}
            </p>
        </div>
        <div class="header-title top" @click="goBack()" v-else>
            <a href="javascript:;" class="nav-btn-left-color" />
            <p class="common-title-text ellipsis gray" :style="{ color: color }">
                {{ headTitle }}
            </p>
        </div>
        <!-- $store.state.user_origin !== 'not_staff' &&
                $store.state.qr_permission &&
                $store.state.qr_permission['choice_equipment_son'] && -->
        <div v-if="showHome && $store.state.account_origin !== 'not_staff'" class="icon_home" @click="drowHome">
            <img src="@/assets/images/eqip-icon/icon_home.png"  />
        </div>
        <div
            :class="[agent === 'Android' ? 'switch_img_box_top' : '', 'switch_img_box']"
            @click="$_switchEquipment"
            v-if="
                showIcon &&
                $store.state.user_origin !== 'not_staff' &&
                $store.state.qr_permission &&
                $store.state.qr_permission['choice_equipment_son']
            "
        >
            <img src="@/assets/images/icon_turn_switch.png" class="switch_img" />
        </div>
        <!-- v-if="agent === 'Android' && showIcon" -->
        <div class="translate-guide-box" v-if="agent === 'Android' && showIcon" @click="translateGuide">
            <span class="translate-text">Translate Guide</span>
            <img src="@/assets/images/icon_up_arrow.png" class="translate-img" />
        </div>
        <div v-if="showFilter" class="icon_search" @click="searchClick">
            <img src="@/assets/images/icon_filter_search.png"  />
        </div>
    </div>
</template>

<script>
/*
 * @name: 导航头部
 * @description:导航头部，headTitle 标题  bg 背景图片
 * @author: zefeng(zefeng.chen@shengyc.com)
 * @Date: 2019-05-13 13:57:16
 * @LastEditTime: 2019-05-13 13:57:16
 */

import { isWeiXin } from '@/config/Utils'
import { userAgent } from '@/config/Utils'
export default {
    created() {
        // document.title = this.inputHeadTitle || this.headTitle
        this.hideCover = isWeiXin()
        this.judgeAgent()
    },
    data() {
        return {
            hideCover: '',
            agent: '',
        }
    },
    props: {
        // key_word: {
        //     type: String,
        //     default: '4',
        // },
        position: {
            type: String,
            default: 'relative',
        },
        headTitle: {
            type: String,
        },
        // coverBg: {
        //     type: String,
        // },
        router: {
            type: String,
            default: '',
        },
        bg: {
            type: String,
            default: '#3766E1',
        },
        color: {
            type: String,
            default: '#0152b4',
        },
        top: {
            type: String,
            default: '0',
        },
        align: {
            type: String,
            default: 'center',
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
        showHome: {
            type: Boolean,
            default: false,
        },
        showFilter: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        // 回到首页
        drowHome () {
            this.$router.push('/main')
        },
        // 如果是绑定页面回去登录页面
        goBack() { 
            let from_path = this.$route.query && this.$route.query.from_path
            if (from_path === '/login' && this.$route.path === '/wechatBindingScreen') {
                this.$_login()
            } else if (this.router) {
                this.$router.push(this.router)
            } else {
                this.$router.back()
            } 
        },
        // 回到登录页面
        $_login() {
            if (isWeiXin()) {
                //需要重定向跳转页面，所以只能在这里进行手动授权
                let path = this.$route.path
                let redirect_uri = encodeURIComponent(
                    // eslint-disable-next-line no-undef
                    process.env.VUE_APP_URL_WELINK + '#/login?from_path=' + path
                )
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_WX_AUTHOR_APPID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
            } else {
                this.$store.commit('updateLoginTabName', 'smas_login')
                this.$router.push('/login')
            }
        },
        $_switchEquipment() {
            if (this.user_origin == 'oem') {
                this.$router.push({
                    path: '/custormerSearchScreen',
                })
            } else {
                this.$router.push({
                    path: '/equitmentSearchScreen',
                })
            }
        },
        judgeAgent() {
            this.agent = userAgent()
        },
        //跳转翻译页面
        translateGuide() { 
            this.$router.push({
                path: '/translateGuide',
                query: {
                    redirect: window.location.href,
                },
            })
        },

        // 点击搜索
        searchClick () {
            this.$emit('on-search')
            console.log('ddd')
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';

#header-back {
    position: relative;
    // top: 0;
    width: 100% !important;
    display: flex;
    // justify-content: center;
    .switch_img_box {
        position: absolute;
        // top: vw(2);
        z-index: 1000;
        right: vw(15);
        top: vw(12);
        @include wh(vw(23), vw(23));
    }
    .switch_img {
        @include wh(vw(22), vw(22));
        object-fit: cover;
    }
    .switch_img_box_top {
        top: vw(43) !important;
    }
}
.icon_home{
    position: absolute;
    left: vw(55);
    top: vw(10);
    img{
        width: vw(24);
        height: vw(24);
    }
}
.icon_search{
    position: absolute;
    right: vw(10);
    top: vw(10);
    img{
        width: vw(24);
        height: vw(24);
    }
}
.header-title {
    width: 100%;
    padding: vw(10) vw(15);
    position: relative;
    .nav-btn-left {
        // display: inline-block;
        position: absolute;
        left: vw(15);
        @include wh(vw(24), vw(24));
        background: transparent url('~@/assets/images/left_arrow_W.png') no-repeat center center;
        background-size: vw(9), vw(16);
    }
    .nav-btn-left-color {
        // position: absolute;
        margin-top: vw(-1);
        @include wh(vw(20), vw(24));
        background: transparent url('~@/assets/images/icon_back.png') no-repeat center center;
        background-size: vw(20), vw(20);
        margin-left: vw(14);
    }
    .common-title-text {
        line-height: vw(24);
        font-size: vw(17);
        // display: inline-block;
        margin-left: vw(20);
    }
    .gray {
        color: #666666;
        font-size: vw(15) !important;
        margin-top: vw(-1);
        margin-left: 0 !important;
    }
}
.top {
    margin-top: vw(10);
    padding-bottom: 0;
    display: flex;
    align-items: center;
}
.flex {
    width: 100%;
    display: flex;
    justify-content: center;
}
.translate-guide-box {
    width: vw(115);
    display: flex;
    align-items: center;
    position: absolute;
    top: vw(16);
    right: 0;
    .translate-text {
        color: #ffffff;
        font-size: vw(12);
    }
    .translate-img {
        width: vw(12);
        height: vw(12);
    }
}
</style>
